import React, { PureComponent } from 'react';
import { Shadow } from '@qnpm/q-shadow';
import { Colors } from '@qnpm/q-theme';
import { getCardStyles } from './handle';
import { View } from 'react-native';
const { scenes: { baseColor } } = Colors;
export default class Card extends PureComponent {
    render() {
        const { shadow, children, style } = this.props;
        const cardStyle = getCardStyles(this.props);
        let tShadow = shadow ? shadow : 'none';
        return shadow === 'none' ? (<View style={[style, cardStyle]}>{children}</View>) : (<Shadow shadow={tShadow} style={[style, cardStyle]}>
                {children}
            </Shadow>);
    }
}
Card.defaultProps = {
    needScale: false,
    radius: 'none',
    backgroundColor: baseColor.white,
    shadow: 'none',
    opacity: 1
};
